import { MekUser } from "./api";

const mySenecBusinessSystemCode = "senec-meinSENEC";

export function extractDevNumber(user: MekUser): string | undefined {
    const mySenecRef = findMySenecBusinessSystemRef(user);
    return mySenecRef?.referenceId;
}

function findMySenecBusinessSystemRef(user: MekUser): MySenecBusinessSystemRef | undefined {
    return user["https://login.ciam.com/identity_v2"].businessSystemReferences.find((ref) => isMySenecBusinessSystemRef(ref)) as
        | MySenecBusinessSystemRef
        | undefined;
}

type MySenecBusinessSystemRef = {
    businessSystemCode: typeof mySenecBusinessSystemCode;
    referenceId: string;
};

function isMySenecBusinessSystemRef(businessSystemRef: unknown): businessSystemRef is MySenecBusinessSystemRef {
    return (
        businessSystemRef !== null &&
        typeof businessSystemRef === "object" &&
        "businessSystemCode" in businessSystemRef &&
        "referenceId" in businessSystemRef &&
        businessSystemRef.businessSystemCode === mySenecBusinessSystemCode &&
        typeof businessSystemRef.referenceId === "string"
    );
}
